/**
 * Ryan O'Dowd
 * 2025-05-10
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = () => {
  return {
    container: (size) => {
      return {
        width: size,
        height: size,
      };
    },
  };
};

export default getStyles;
